import favoriteAssetsApiDefinition from './api/index.js'
import { favoriteAssetsAtomDefinition } from './atoms/index.js'
import favoriteAssetsModuleDefinition from './module/index.js'
import {
  favoriteAssetsAnalyticsPluginDefinition,
  favoriteAssetsLifecyclePluginDefinition,
} from './plugins/index.js'

const DEFAULT_MAXIMUM_FAVORITES_COUNT = Infinity

const favoriteAssets = (
  {
    maximumFavoritesCount = DEFAULT_MAXIMUM_FAVORITES_COUNT,
    defaultFavoriteAssets = {},
  } = Object.create(null)
) => ({
  id: 'favoriteAssets',
  definitions: [
    {
      definition: favoriteAssetsAtomDefinition,
      config: {
        defaultValue: defaultFavoriteAssets,
      },
    },
    {
      definition: favoriteAssetsModuleDefinition,
      config: {
        maximumFavoritesCount,
      },
    },
    { definition: favoriteAssetsApiDefinition },
    { definition: favoriteAssetsLifecyclePluginDefinition },
    {
      if: { registered: ['analytics'] },
      definition: favoriteAssetsAnalyticsPluginDefinition,
    },
  ],
})

export default favoriteAssets
